/**
 * Pricing Tabs — two-tab toggle showing/hiding pricing cards by tab assignment.
 */
(function () {
  document.querySelectorAll('.pricing-tabs').forEach(function(section) {
    var toggleButtons = section.querySelectorAll('.pricing-toggle-btn');
    var cards = section.querySelectorAll('.pricing-card');

    toggleButtons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var tab = btn.dataset.tab;
        toggleButtons.forEach(function(b) {
          b.classList.toggle('is-active', b.dataset.tab === tab);
          b.setAttribute('aria-pressed', b.dataset.tab === tab);
        });
        cards.forEach(function(card) {
          card.hidden = card.dataset.tab !== tab;
        });
      });
    });
  });
})();
